import React from 'react';
import { Switch, Route } from 'react-router-dom';

import HomepageContainer from './HomepageContainer';
import UserProfile from '../User/UserProfile/UserProfile';

const Routes = (): React.JSX.Element => (
  <Switch>
    <Route exact path="/dashboard">
      <HomepageContainer />
    </Route>
    <Route exact path="/dashboard/user/profile">
      <UserProfile />
    </Route>
  </Switch>
);

export default Routes;
